import { router, setPageContent } from "..";
import { getFencealarmVoltage } from "../api/fencealarms_{imei}";
import { lineChart } from "../device/device_log_chart";
import { t } from "../locale";
import { state } from "../state";
import { Bulma } from "../view/bulma";
import { centeredBox } from "../view/components";

/**
 * @type {import('navigo').Handler}
 */
async function fencealarmLogsPage(ctx) {
	if (!ctx?.data?.imei) throw "missing ctx.data.imei";
	const fa = state.fencealarms[ctx.data.imei];

	const voltageChart = lineChart({
		label: t.voltage,
		unit: "Volt",
		device: {
			type: "FenceAlarm",
			serialNumber: fa.Imei,
		},
		getData: getVoltage,
	});

	setPageContent(
		centeredBox(
			"large",
			Bulma.title(fa.Metadata.Name),
			Bulma.subtitle(`IMEI: ${fa.Imei}`),
			document.createElement("hr"),
			Bulma.title(t.voltage, "is-5"),
			voltageChart.element,
			Bulma.buttons(
				Bulma.button(
					{
						onClick: () => router.jump(`/devices?id=${fa.Imei}`),
						styles: ["is-primary"],
					},
					t.back,
				),
			),
		),
	);

	voltageChart.mount();

	/**
	 * @param {Date} from
	 * @param {Date} to
	 * @param {"csv"|"json"|"xlsx"} format
	 * @returns {Promise<import('../device/device_log_chart').DataPoint[]|Blob>}
	 */
	async function getVoltage(from, to, format) {
		const res = await getFencealarmVoltage(fa.Imei, {
			from: from.toISOString(),
			to: to.toISOString(),
			format: format,
		});

		if (res instanceof Blob) return res;
		else
			return res.map((log) => ({
				value: log.Voltage,
				timestamp: log.Timestamp,
			}));
	}
}

export { fencealarmLogsPage };
